import React from "react";
import { Button } from "react-bootstrap";

function Feedback(props) {
  const feedbackButtonStyle = {
    color: "black",
    backgroundColor: "white",
    margin: "10px",
    display: "inline-block",
    width: "initial",
    borderRadius: "0",
    marginBottom: "6vh",
    backgroundImage: "none",
    textTransform: "uppercase"
  };
  const buttonHolderStyle = {
    width: "100%",
    textAlign: "center"
  };
  return (
    <div style={buttonHolderStyle}>
      <Button
        className="button"
        style={feedbackButtonStyle}
        href="mailto:support@craicbox.app?subject=Craicbox - Feedback"
        type="submit">
        Feedback
      </Button>
    </div>
  );
}

export default Feedback;